export class RetailerType {
  constructor(
    public id: number,
    public name: string
  ) { }
}
